// extracted by mini-css-extract-plugin
export var button = "_ch-4";
export var hasDarkBackground = "_ch-7";
export var hasLightBackground = "_ch-6";
export var iconWrapper = "_ch-0";
export var large = "_ch-2";
export var medium = "_ch-1";
export var small = "_ch-5";
export var xsmall = "_ch-3";